module.exports = __webpack_public_path__ + "img/84.42b7a98b.jpg";